import { Component, Input } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  imports: [
    NgIf,
    NgClass
  ]
})
export class LayoutComponent {

  @Input()
  public fullscreen = false;

}
